import { useState } from 'react';
import InteractivePhoneFrame from './components/InteractivePhoneFrame';
import Footer from './components/Footer';
import DownloadSection from './components/DownloadSection';
import FeaturesSection from './components/FeaturesSection';
import Header from './components/Header';
import MobileMenu from './components/MobileMenu';
import { PersonaSections } from './components/PersonaSection';
import { personaSections } from './data/content';
import { getElementAnimation } from './utils/animations';
import { useResponsive } from './hooks/useResponsive';

function AppDownloadPage() {
  const isMobile = useResponsive();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div style={styles.container}>
      <Header isMobile={isMobile} onMenuToggle={() => setMenuOpen(!menuOpen)} />
      <MobileMenu menuOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      <InteractivePhoneFrame isMobile={isMobile} />
      <PersonaSections
        personaSections={personaSections}
        isMobile={isMobile}
        getElementAnimation={getElementAnimation}
      />
      <FeaturesSection isMobile={isMobile} />
      <DownloadSection isMobile={isMobile} />
      <Footer />
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
    color: '#1e293b',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
};

export default AppDownloadPage;

